import { render, staticRenderFns } from "./academic_font_management_home.vue?vue&type=template&id=df314dec&scoped=true"
import script from "./academic_font_management_home.vue?vue&type=script&lang=js"
export * from "./academic_font_management_home.vue?vue&type=script&lang=js"
import style0 from "./academic_font_management_home.vue?vue&type=style&index=0&id=df314dec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df314dec",
  null
  
)

export default component.exports